import * as actions from "./actions";
import * as mutations from "./mutations";

export default {
  namespaced: true,

  state: {
    showVikiMsg: {
      show: false,
      id: "",
      msg: "",
      type: "",
      op: {
        type: "",
        clientId: null
      }
    },
    auth: {
      token: localStorage.getItem("user-token") || "",
      user: {
        id: null,
        email: null,
        role: null,
        first_name: null,
        last_name: null,
        backup_voip_enable: null,
        voip_user: null,
        backup_voip_user: null,
        profile_img: null,
        team_id: null,
        socket_session_id: null,
        seniority: null,
        extra: {},
        user_shifts: []
      }
    },
    badAttemptToLogIn: false,
    errorInfo: null
  },
  mutations,
  actions,
  getters: {

    showVikiMsg: state => {
      return state.showVikiMsg;
    },

    getUserId: state => {
      return state.auth.user.id;
    },
    userRole: state => {
      return state.auth.user.role;
    },
    isLogged: state => {
      return !!state.auth.token;
    }
  }
};
